/**
 * App sales report, which lets resellers view the charges and payments per their app
 *  (More info tbd)
 */

import PropTypes from 'prop-types';
import { Grid, TablePagination, TextField, Typography } from "@mui/material";
import React, { Component } from "react";
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from "react-relay";
import AbEnvironment from "../auth/AbEnvironment";
import LoadingSpinner from "../ui/LoadingSpinner";
import ServerError from "../ui/ServerError";
import ChargesList from "../account/ChargesList";
import { withStyles } from "@mui/styles";
import { addDays, isValid, startOfDay, subMonths } from "date-fns";
import { DatePicker } from '@mui/x-date-pickers';
import SearchField from "../ui/SearchField";
import AppBindStyles from "../../AppBindStyles";

const abEnvironment = new AbEnvironment();
const AppSalesReportQuery = graphql`
query AppSalesReportQuery(
  $appId: UUID!
  $resellerAccountId: UUID!
  $accountName: String
  $startTs: Datetime
  $endTs: Datetime
  $first: Int
  $offset: Int
) {
  getchargesexternalsandpaymentswithsummary(
    startTs: $startTs
    endTs: $endTs
    appId: $appId
    pAccountId: $resellerAccountId
    accountName: $accountName
    first: $first
    offset: $offset
  ) {
    totalCount
    ...ChargesList_cl
  }
}

`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
  }
});

class AppSalesReport extends Component {

  constructor(props) {
    super(props);

    // Default toDate
    let appSalesToDate = new Date();
    let tDate = localStorage.getItem('appSalesToDate');
    if (tDate != null) {
      appSalesToDate = new Date(tDate);
    }
    //search todate should be "start of next day"
    let searchToDateUtc = startOfDay(addDays(appSalesToDate, 1)).toISOString();

    let appSalesFromDate = new Date();
    let fDate = localStorage.getItem('appSalesFromDate');
    if (fDate != null) {
      appSalesFromDate = new Date(fDate);
    } else {
      appSalesFromDate = subMonths(appSalesToDate, 1);
    }
    //search fromdate should be "start of day"
    let searchFromDateUtc = startOfDay(appSalesFromDate).toISOString();

    this.state = {
      startDate: appSalesFromDate,
      queryStartDateUtc: searchFromDateUtc,
      endDate: appSalesToDate,
      queryEndDateUtc: searchToDateUtc,
      accountName: '',
      page: 0,
      rowsPerPage: 10
    };
  }

  setFromDate(theDate) {
    let vdate = new Date(theDate); // Start of date local timezone.
    if (isValid(vdate)) {
      localStorage.setItem('appSalesFromDate', vdate);
      let searchDateUtc = startOfDay(vdate).toISOString();
      this.setState({ startDate: vdate, queryStartDateUtc: searchDateUtc, page: 0 });
    }
  }

  setToDate(theDate) {
    let vdate = new Date(theDate);
    if (isValid(vdate)) {
      localStorage.setItem('appSalesToDate', vdate);
      let searchDateUtc = startOfDay(addDays(vdate, 1)).toISOString();
      this.setState({ endDate: vdate, queryEndDateUtc: searchDateUtc, page: 0 });
    }
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ page: page });
  }


  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page: 0 });
  }

  render() {
    const { isAuthenticatedReseller, isAuthenticated, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;


    if (!isAuthenticated() || needAssent()) {
      return (
        <div>
          <Typography variant="body1">App sales not available. Please login again.</Typography>
        </div>
      );
    } else if (isAuthenticatedReseller()) {
      const { appId } = this.props;
      const myAccountId = abEnvironment.getUserAttribute("a_id");

      let customerAccountNameSearch = '%';
      if (this.state.accountName && this.state.accountName.length > 0)
        customerAccountNameSearch = '%' + this.state.accountName + '%';

      // Determine the offset
      let offset = 0;
      if (this.state.page > 0) {
        offset = this.state.page * this.state.rowsPerPage
      }
      
      let first = this.state.rowsPerPage;

      let totalCount = 0;

      return (
        <div className={classes.root} >
          <Grid container spacing={2} alignItems='center' style={AppBindStyles.searchContainerOnPaper}>
            <Grid item>
              <SearchField
                id="accountName"
                label="Search by customer account name"
                value={this.state.accountName}
                onChange={this.handleChange('accountName')}
              />
            </Grid>
            <Grid item style={AppBindStyles.datePickerField}>
              <DatePicker
                disableFuture
                label="From date"
                value={this.state.startDate}
                onChange={(newValue) => {
                  this.setFromDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      svg: { paddingRight: '2px' }
                    }}
                  />
                )}
              />
            </Grid>

            <Grid item style={AppBindStyles.datePickerField}>
              <DatePicker
                disableFuture
                label="To date"
                value={this.state.endDate}
                onChange={(newValue) => {
                  this.setToDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      svg: { paddingRight: '2px' }
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={AppSalesReportQuery}
            variables={{
              appId: appId,
              resellerAccountId: myAccountId,
              accountName: customerAccountNameSearch,
              startTs: this.state.queryStartDateUtc,
              endTs: this.state.queryEndDateUtc,
              first: first,
              offset: offset
            }}
            render={({ error, props }) => {
              if (error) {
                logError(error.message);
                return (
                  <ServerError />
                );
              } else if (props) {
                if (props.getchargesexternalsandpaymentswithsummary === null) {
                  return (
                    <div className={classes.root}>
                      <Typography>App sales not found.</Typography>
                    </div>
                  );
                }

                totalCount = props.getchargesexternalsandpaymentswithsummary.totalCount;

                return(
                  <div>
                    <ChargesList
                      cl={props.getchargesexternalsandpaymentswithsummary}
                      theRole={"reseller"}
                      thePage={"appCharge"}
                      sn={true}
                      history={this.props.history}
                    />
                    <div style={{marginTop: '10px'}}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                );
              }

              return <LoadingSpinner />
            }}
          />
        </div>
      )
    }
  }
}

AppSalesReport.propTypes = {
  appId: PropTypes.string.isRequired,
  resellerAccountId: PropTypes.string.isRequired
};

export default withStyles(styleSheet)(AppSalesReport);